<template>
  <div>
    <div>
      <div class="d-flex align-center mb-4 mt-5">
        <v-icon color="#277faf" class="mr-2">mdi-file-cog-outline</v-icon>
        <BaseInput
          :items="pageSizeList"
          v-model="pageSizeEdit"
          type="autocomplete"
          minimize
          class="flex-grow-1"
          @change="updateData('pageSize', pageSizeEdit)"
        />
      </div>
      <div class="d-flex align-center mb-4">
        <v-icon color="#277faf" class="mr-2">mdi-phone-rotate-landscape</v-icon>
        <BaseInput
          :items="pageOrientationList"
          v-model="pageOrientationEdit"
          type="autocomplete"
          minimize
          class="flex-grow-1"
          @change="updateData('pageOrientation', pageOrientationEdit)"
        />
      </div>
      <div v-if="fileName" class="d-flex align-center mb-4">
        <v-icon color="#277faf" class="mr-2">mdi-file-edit-outline</v-icon>
        <BaseInput v-model="fileNameEdit" height="30" class="flex-grow-1" @change="updateData('fileNameEdit', fileNameEdit)"/>
      </div>
    </div>
    <v-divider class="mb-4"/>
    <slot />
    <v-divider class="mb-4"/>
    <div v-for="(item, i) in items" :key="'list_' + i">
      <div v-if="i !== 0 && (items[i - 1] && !items[i - 1].doc) && !item.doc" class="d-flex align-center justify-center mb-4">
        <v-icon color="#277faf" class="mr-4">mdi-format-page-break</v-icon>
        <BaseInput
          v-model="item.breakpage"
          type="switch"
          @input="updateItem(i, 'breakpage', item.breakpage)"
        />
      </div>
      <div class="mb-4 border py-2">
        <template v-if="item.image || item.imageUpload">
          <v-img :src="item.imageUpload ? item.data : apiDomain + '/min/' + item.image" max-width="100" height="100" contain class="mx-auto" />
          <div class="d-flex align-center ma-2">
            <v-icon color="#277faf" class="mr-2">mdi-arrow-expand-all</v-icon>
            <BaseInput
              :items="imageSizeList"
              v-model="item.size"
              @change="updateItem(i, 'size', item.size)"
              type="autocomplete"
              minimize
            />
          </div>
        </template>
        <template v-else-if="item.doc">
          <div class="d-flex align-center justify-space-around">
            <v-card :max-width="100" flat tile color="transparent">
              <pdf :src="item.data" :page="1" class="mb-1" />
            </v-card>
            <IconFileFormat pdf class="mx-2" width="30" height="30" color="#277faf"/>
          </div>
        </template>
        <BaseInput v-else v-model="item.text" readonly height="30" class="mx-2" />
        <div class="d-flex justify-space-around align-center">
          <v-btn icon color="#277faf" :disabled="i === 0" @click="itemUp(i)">
            <v-icon>mdi-arrow-up-bold</v-icon>
          </v-btn>
          <v-btn icon color="#277faf" :disabled="i === items.length - 1" @click="itemDown(i)">
            <v-icon>mdi-arrow-down-bold</v-icon>
          </v-btn>
          <v-btn icon color="#277faf" @click="itemEdit(i)" :disabled="!!item.doc">
            <v-icon v-if="item.image || item.imageUpload">mdi-pencil</v-icon>
          </v-btn>
          <v-btn icon color="red" @click="delItem(i)">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
      </div>
    </div>
    <v-dialog v-if="delDialog" v-model="delDialog" width="400">
      <v-card class="pa-4">
        <v-btn icon absolute right top class="mt-n2 mr-n2" @click="delDialog = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
        <h3 class="text-center">{{ localStorage.translations.pages.common.buttons.udalit }} ?</h3>
        <div class="d-flex justify-space-around mt-8">
          <v-hover v-slot="{ hover }">
            <v-btn fab :outlined="!hover" :depressed="!hover" dark color="red" @click="delDialog = false">
              <v-icon>mdi-close</v-icon>
            </v-btn>
          </v-hover>
          <v-hover v-slot="{ hover }">
            <v-btn
              fab :depressed="!hover" :outlined="!hover" :dark="hover"
              color="#26bc2c"
              @click="onDeleteItem()"
            >
              <v-icon>mdi-check</v-icon>
            </v-btn>
          </v-hover>
        </div>
      </v-card>
    </v-dialog>
    <v-dialog v-model="cropDialog" fullscreen scrollable transition="dialog-bottom-transition">
      <v-card color="#2e3133" tile>
        <v-sheet
          color="transparent"
          max-width="100vw" max-height="calc(100vh - 60px)"
          height="calc(100vh - 60px)"
          class="d-flex flex-column align-center justify-space-around pb-5"
        >
          <div class="d-flex align-center flex-grow-1">
            <clipper-basic
              :src="cropItem.url"
              :rotate="cropItem.rotate"
              :scale="cropItem.scale / 100"
              :wrap-ratio="1"
              bg-color="black"
              ref="clipper"
            />
            <div class="pl-10">
              <v-slider
                vertical
                v-model="cropItem.scale"
                max="200"
                min="20"
                hide-details
                style="height: 100%"
              />
            </div>
          </div>
          <div style="width: 80%">
            <v-slider
              v-model="cropItem.rotate"
              :label="cropItem.rotate + '°'"
              max="180"
              min="-180"
              hide-details
            />
          </div>
          <div class="d-flex align-center justify-space-around" style="width: 90%">
            <v-btn fab dark @click="closeCropDialog()">
              <v-icon>mdi-undo-variant</v-icon>
            </v-btn>
            <v-btn fab dark @click="saveCrop()">
              <v-icon>mdi-check</v-icon>
            </v-btn>
          </div>
        </v-sheet>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import pdf from 'vue-pdf'
import IconFileFormat from "components/icons/IconFileFormat"

export default {
  name: "PdfDocumentCreateNav",
  components: {
    pdf,
    IconFileFormat,
  },
  props: {
    items: {
      type: Array,
      default: () => {
        return []
      }
    },
    fileName: {
      type: [Boolean, String],
      default: 'optional name'
    },
    pageSize: {
      type: String,
      default: 'A4'
    },
    pageOrientation: {
      type: String,
      default: 'portrait'
    },
    onUpdateField: {},
    onUpdatePosition: {},
    onUpdateImage: {}
  },
  computed: {
    ...mapGetters(['apiDomain']),
    t() {
      return this.localStorage.translations.pages['setting-free_documents']['dialogs_labels']
    },
    pageOrientationList() {
      return [
        {id: 'portrait', name: this.t['portrait']},
        {id: 'landscape', name: this.t['landscape']},
      ]
    },
    imageSizeList() {
      return [
        {id: 'auto', name: this.t['auto']},
        {id: 'cover', name: this.t['cover']},
        {id: 'contain', name: this.t['contain']},
        {id: 90, name: '90%'},
        {id: 75, name: '75%'},
        {id: 50, name: '50%'},
        {id: 25, name: '25%'},
      ]
    },
  },
  data: () => ({
    pageSizeEdit: 'A4',
    pageOrientationEdit: 'portrait',
    pageSizeList: [
      '4A0', '2A0', 'A0', 'A1', 'A2', 'A3', 'A4', 'A5', 'A6', 'A7', 'A8', 'A9', 'A10',
      'B0', 'B1', 'B2', 'B3', 'B4', 'B5', 'B6', 'B7', 'B8', 'B9', 'B10',
      'C0', 'C1', 'C2', 'C3', 'C4', 'C5', 'C6', 'C7', 'C8', 'C9', 'C10',
      'RA0', 'RA1', 'RA2', 'RA3', 'RA4',
      'SRA0', 'SRA1', 'SRA2', 'SRA3', 'SRA4',
      'EXECUTIVE', 'FOLIO', 'LEGAL', 'LETTER', 'TABLOID'
    ],
    pageSizes: {
      '4A0': [4767.87, 6740.79],
      '2A0': [3370.39, 4767.87],
      A0: [2383.94, 3370.39],
      A1: [1683.78, 2383.94],
      A2: [1190.55, 1683.78],
      A3: [841.89, 1190.55],
      A4: [595.28, 841.89],
      A5: [419.53, 595.28],
      A6: [297.64, 419.53],
      A7: [209.76, 297.64],
      A8: [147.4, 209.76],
      A9: [104.88, 147.4],
      A10: [73.7, 104.88],
      B0: [2834.65, 4008.19],
      B1: [2004.09, 2834.65],
      B2: [1417.32, 2004.09],
      B3: [1000.63, 1417.32],
      B4: [708.66, 1000.63],
      B5: [498.9, 708.66],
      B6: [354.33, 498.9],
      B7: [249.45, 354.33],
      B8: [175.75, 249.45],
      B9: [124.72, 175.75],
      B10: [87.87, 124.72],
      C0: [2599.37, 3676.54],
      C1: [1836.85, 2599.37],
      C2: [1298.27, 1836.85],
      C3: [918.43, 1298.27],
      C4: [649.13, 918.43],
      C5: [459.21, 649.13],
      C6: [323.15, 459.21],
      C7: [229.61, 323.15],
      C8: [161.57, 229.61],
      C9: [113.39, 161.57],
      C10: [79.37, 113.39],
      RA0: [2437.8, 3458.27],
      RA1: [1729.13, 2437.8],
      RA2: [1218.9, 1729.13],
      RA3: [864.57, 1218.9],
      RA4: [609.45, 864.57],
      SRA0: [2551.18, 3628.35],
      SRA1: [1814.17, 2551.18],
      SRA2: [1275.59, 1814.17],
      SRA3: [907.09, 1275.59],
      SRA4: [637.8, 907.09],
      EXECUTIVE: [521.86, 756.0],
      FOLIO: [612.0, 936.0],
      LEGAL: [612.0, 1008.0],
      LETTER: [612.0, 792.0],
      TABLOID: [792.0, 1224.0],
    },
    fileNameEdit: '',
    delId: -1,
    delDialog: false,
    cropDialog: false,
    cropItem: {
      rotate: 0,
      scale: 100,
    },
  }),
  mounted() {
    this.fileNameEdit = this.fileName
    this.pageSizeEdit = this.pageSize
    this.pageOrientationEdit = this.pageOrientation
  },
  methods: {
    updateData(field, data) {
      if (this.onUpdateField) this.onUpdateField(field, data)
    },
    itemUp(i) {
      if (this.onUpdatePosition) this.onUpdatePosition('up', i)
    },
    itemDown(i) {
      if (this.onUpdatePosition) this.onUpdatePosition('down', i)
    },
    itemEdit(i) {
      this.cropItem.id = i
      this.cropItem.file = this.items[i].file
      this.cropItem.url = URL.createObjectURL(this.cropItem.file)
      this.cropDialog = true
    },
    delItem(i) {
      this.delId = i
      this.delDialog = true
    },
    onDeleteItem() {
      if (this.onUpdatePosition) this.onUpdatePosition('delete', this.delId)
      this.delDialog = false
    },
    closeCropDialog() {
      this.cropItem.id = -1
      this.cropItem.file = null
      this.cropItem.url = null
      this.cropDialog = false
    },
    saveCrop() {
      const canvas = this.$refs.clipper.clip()
      const canvasData = this.$refs.clipper.getDrawPos()
      let quality = canvasData.pos && (canvasData.pos.sheight > 1000 || canvasData.pos.swidth > 1000) ? 0.7 : 1
      let resultURL = canvas.toDataURL("image/jpeg", quality)
      if (this.onUpdateImage) this.onUpdateImage(this.cropItem.id, resultURL)
      this.closeCropDialog()
    },
    updateItem(i, field, value) {
      if (this.onUpdateField) this.onUpdateField(field, value, i)
    }
  }
}
</script>

<style scoped lang="scss">
.border {
  border: 1px solid rgba(black, 0.04);
  border-radius: 4px;
}

:deep() .vuejs-clipper-basic__stem-canvas {
  min-height: 40vh !important;
  min-width: 40vw !important;
  max-height: 80vh !important;
  max-width: 80vw !important;
}
</style>